import { PositionsSearchFilter } from "_graphql-types/graphql";
import { Tag } from "frontend/src/components/Tag/Tag";
import { removeFilter } from "Reducers/globalSearchV2/globalSearchV2.actions";
import { useDispatch } from "src/react-redux";

function PositionsFilterTag({ filter }: { filter: PositionsSearchFilter }) {
  const dispatch = useDispatch();

  const parts: string[] = [];
  if (filter.securityNames?.length) {
    parts.push(filter.securityNames.join(", "));
  }
  if (filter.tickers?.length) {
    parts.push(filter.tickers.map(t => `$${t}`).join(", "));
  }

  return (
    <Tag
      className="ant-tag--blue ant-tag--close"
      data-cy="positions-filter-tag"
      onClose={() => {
        dispatch(
          removeFilter({
            type: "investment",
            data: {
              type: "investment",
              data: {
                type: "POSITIONS",
                data: filter,
              },
            },
          })
        );
      }}
      closable
    >
      Positions: {parts.join(", ")}
    </Tag>
  );
}

export default PositionsFilterTag;
